import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { getInitialTheme } from "./hooks/useTheme";

// Apply the theme before the first paint so dark mode never flashes white.
document.documentElement.classList.toggle("dark", getInitialTheme() === "dark");
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-275" data-mp="2abfb335hdko9" />);
}